(() => {
  const setup = () => document.querySelectorAll('[data-bitig-reviews]').forEach(modal => {
    if (modal.dataset.ready) return;
    const widget = document.querySelector(`.jdgm-review-widget[data-product-id="${modal.dataset.productId}"]`);
    const trigger = document.querySelector('.bitig-rating');
    if (!widget || !trigger) return;
    modal.dataset.ready = 'true';
    document.body.append(modal);
    modal.querySelector('.bitig-review-modal__host').append(widget);
    const panel = modal.querySelector('[role="dialog"]');
    const closeButton = modal.querySelector('.bitig-review-modal__close');
    const sync = () => {
      const badge = trigger.querySelector('[data-number-of-reviews]');
      const count = Number(badge?.dataset.numberOfReviews || 0);
      const average = Number(badge?.dataset.averageRating || 0);
      modal.dataset.empty = String(count === 0);
      modal.querySelector('[data-review-score]').hidden = !count;
      modal.querySelector('[data-review-average]').textContent = average.toFixed(1);
      modal.querySelector('[data-review-stars]').style.width = `${Math.max(0,Math.min(100,average * 20))}%`;
      modal.querySelector('[data-review-count]').textContent = count ? `${count} ${modal.dataset.reviewsLabel}` : modal.dataset.noReviews;
      modal.querySelector('[data-review-empty]').hidden = !!count;
      trigger.querySelectorAll('[role="button"]').forEach(el => { el.removeAttribute('role'); el.removeAttribute('tabindex'); });
    };
    trigger.setAttribute('role','button');
    trigger.setAttribute('tabindex','0');
    trigger.setAttribute('aria-controls',modal.id);
    trigger.setAttribute('aria-expanded','false');
    trigger.setAttribute('aria-haspopup','dialog');
    trigger.setAttribute('aria-label',modal.querySelector('h2').textContent);
    let inertElements = [];
    const open = () => {
      sync(); modal.hidden = false; modal.setAttribute('aria-hidden','false'); trigger.setAttribute('aria-expanded','true');
      document.body.classList.add('bitig-reviews-open');
      inertElements = [...document.body.children].filter(el => el !== modal && !el.matches('.jdgm-review-widget-modal') && !el.inert && !['SCRIPT','STYLE','LINK'].includes(el.tagName));
      inertElements.forEach(el => { el.inert = true; });
      modal.querySelector('.bitig-review-modal__body').scrollTop = 0;
      requestAnimationFrame(() => { closeButton.focus(); window.dispatchEvent(new Event('resize')); });
    };
    const close = () => {
      modal.hidden = true; modal.setAttribute('aria-hidden','true'); trigger.setAttribute('aria-expanded','false');
      document.body.classList.remove('bitig-reviews-open');
      inertElements.forEach(el => { el.inert = false; }); inertElements = [];
      trigger.focus();
    };
    trigger.addEventListener('click',event => {event.preventDefault();event.stopImmediatePropagation();open();},true);
    trigger.addEventListener('keydown',event => {if (event.key === 'Enter' || event.key === ' ') {event.preventDefault();open();}});
    modal.querySelectorAll('[data-review-close]').forEach(button => button.addEventListener('click',close));
    document.addEventListener('keydown',event => {
      if (modal.hidden) return;
      const activeDialog = event.target.closest?.('[role="dialog"],dialog');
      if (activeDialog && activeDialog !== panel) return;
      if (event.key === 'Escape') { event.preventDefault(); close(); }
      if (event.key !== 'Tab') return;
      const focusables = [...panel.querySelectorAll('a[href],button,input,select,textarea,[tabindex="0"]')].filter(el => !el.disabled && el.getClientRects().length);
      const first = focusables[0], last = focusables[focusables.length - 1];
      if (event.shiftKey && document.activeElement === first) {event.preventDefault();last?.focus();}
      else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first?.focus();}
    });
    sync();
    new MutationObserver(sync).observe(trigger,{childList:true,subtree:true,attributes:true,attributeFilter:['data-number-of-reviews','data-average-rating']});
  });
  const start = () => { setup(); let attempts=0; const retry=setInterval(()=>{setup();if(++attempts>=40 || !document.querySelector('[data-bitig-reviews]:not([data-ready])'))clearInterval(retry);},250); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',start,{once:true}); else start();
  document.addEventListener('shopify:section:load',start);
})();
